module.exports = __webpack_public_path__ + "img/frame (38).b51a15b4.jpg";